import React, { useState, useEffect, useRef } from "react";
import "./ForgotPassword.css";
import { Spinner } from "@chakra-ui/react";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import { Eye, EyeOff } from "lucide-react";
import { useDispatch } from "react-redux";
import { sentEmpOtp, verifyEmpOtp, changePassword } from "../../../../redux/api/admin/authApi";
const AdminForgotPassWord = () => {
  const [email, setEmail] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [isOtpVerified, setIsOtpVerified] = useState(false);
  const [timer, setTimer] = useState(0);
  const [timerActive, setTimerActive] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [passwordError, setPasswordError] = useState("");
  const [otpSent, setOtpSent] = useState(false);
  const [otp, setOtp] = useState(["", "", "", ""]);
  const combinedOtp = otp.join("");
  const inputRefs = useRef([]);

  const togglePasswordVisibility = () => {
    setShowPassword((prev) => !prev);
  };

  const toggleConfirmPasswordVisibility = () => {
    setShowConfirmPassword((prev) => !prev);
  };
  const dispatch = useDispatch();

  const sendEmail = async (e) => {
    e.preventDefault();

    // Validate email before sending
    if (!email) {
      toast.error("Please enter your email address");
      return;
    }

    const data = {
      email,
    };
    setIsLoading(true);

    try {
      const otpResp = await sentEmpOtp(data);
      console.log("otpResp", otpResp);

      if (otpResp.data.success) {
        setIsLoading(false);
        toast.success("OTP Sent successfully!");
        setOtpSent(true);
        setTimerActive(true);
        setTimer(60); // Set timer for 60 seconds

        // Clear OTP fields
        setOtp(["", "", "", ""]);

      } else if (otpResp.data.status === 203) {
        toast.error(otpResp.data.message || "Invalid OTP.");
        setIsLoading(false);
      } else if (otpResp.data.status === 404) {
        toast.error(otpResp.data.message || "User not found. Please check your email.");
        setIsLoading(false);
      } else {
        toast.error(otpResp.data.message || "Invalid OTP! Please check");
        setIsLoading(false);
      }
    } catch (error) {
      setIsLoading(false);

      // Check if error has a response from the backend
      if (error.response) {
        // The request was made and the server responded with a status code
        // that falls out of the range of 2xx
        const { status, data } = error.response;

        if (status === 404) {
          toast.error(data?.message || "User not found. Please check your email.");
        } else if (status === 500) {
          toast.error(data?.message || "Server error. Please try again later.");
        } else if (status === 400) {
          toast.error(data?.message || "Bad request. Please check your input.");
        } else {
          toast.error(data?.message || `Error: ${status}. Please try again.`);
        }

      } else if (error.request) {
        // The request was made but no response was received
        console.error("No response received:", error.request);
        toast.error("No response from server. Please check your connection.");
      } else {
        // Something happened in setting up the request that triggered an Error
        console.error("Error setting up request:", error.message);
        toast.error("An error occurred. Please try again.");
      }
    }
  };


  useEffect(() => {
    let interval;
    if (timerActive && timer > 0) {
      interval = setInterval(() => {
        setTimer((prev) => prev - 1);
      }, 1000);
    } else if (timer === 0) {
      setTimerActive(false);
      setOtpSent(false); // Allow resending OTP after timer ends
    }
    return () => clearInterval(interval);
  }, [timerActive, timer]);

  const verifyOTP = async (e) => {
    e.preventDefault();

    // Validate OTP before sending
    if (combinedOtp.length !== 4) {
      toast.error("Please enter a 4-digit OTP");
      return;
    }

    if (!email) {
      toast.error("Email is required");
      return;
    }

    const data = {
      email,
      otp: combinedOtp,
    };
    setIsLoading(true);

    try {
      const otpResp = await verifyEmpOtp(data);

      if (otpResp.data.success) {
        setIsLoading(false);
        toast.success("OTP verified successfully!");
        setIsOtpVerified(true);
      } else {
        // Handle specific error status codes from backend
        setIsLoading(false);

        // Check for specific status codes
        if (otpResp.status === 203) {
          toast.error(otpResp.data?.message || "Invalid OTP. Please try again.");
        } else if (otpResp.status === 404) {
          toast.error(otpResp.data?.message || "Email not found.");
        } else if (otpResp.status === 400) {
          toast.error(otpResp.data?.message || "Email and OTP are required.");
        } else {
          toast.error(otpResp.data?.message || "OTP verification failed.");
        }
      }
    } catch (error) {
      setIsLoading(false);

      // Handle Axios/HTTP errors
      if (error.response) {
        const { status, data } = error.response;

        switch (status) {
          case 203:
            toast.error(data?.message || "Invalid OTP. Please try again.");
            break;
          case 400:
            toast.error(data?.message || "Email and OTP are required.");
            break;
          case 404:
            toast.error(data?.message || "Email not found. Please check and try again.");
            break;
          case 500:
            toast.error(data?.message || "Server error. Please try again later.");
            break;
          default:
            toast.error(data?.message || `Error: ${status}. Please try again.`);
        }

      } else if (error.request) {
        console.error("No response received:", error.request);
        toast.error("No response from server. Please check your connection.");
      } else {
        console.error("Error setting up request:", error.message);
        toast.error("An error occurred. Please try again.");
      }
    }
  };


  const handleChange = (index, e) => {
    const value = e.target.value;
    if (!/^\d?$/.test(value)) return;

    const newOtp = [...otp];
    newOtp[index] = value;
    setOtp(newOtp);

    if (value && index < inputRefs.current.length - 1) {
      inputRefs.current[index + 1].focus();
    }
  };

  const handleKeyDown = (index, e) => {
    if (e.key === "Backspace" && !otp[index] && index > 0)
      inputRefs.current[index - 1].focus();
  };

  const handleChangePassword = async (e) => {
    e.preventDefault();

    // Frontend validation
    if (password.length < 8) {
      setPasswordError("Password must be at least 8 characters long.");
      return;
    } else if (password !== confirmPassword) {
      setPasswordError("Passwords do not match!");
      return;
    }
    setPasswordError("");

    const data = {
      newPassword: password,
      confPassword: confirmPassword,
      email: email,
    };
    setIsLoading(true);

    try {
      const response = await changePassword(data);
      console.log("Password change response:", response);

      // Check if response.data exists and has success property
      if (response.data && response.data.success) {
        setIsLoading(false);
        toast.success(response.data.message || "Password changed successfully!");
        navigate("/admin-login");
      } else if (response.data) {
        // Handle backend error responses
        setIsLoading(false);

        // Check for specific error messages from backend
        if (response.data.msg === "Invalid Email") {
          toast.error("Invalid email address. Please check your email.");
        } else if (response.data.error) {
          toast.error(`Error: ${response.data.error}`);
        } else if (response.data.message) {
          toast.error(response.data.message);
        } else {
          toast.error("Failed to change password. Please try again.");
        }
      } else {
        // If response structure is unexpected
        setIsLoading(false);
        toast.error("Unexpected response from server. Please try again.");
      }
    } catch (error) {
      setIsLoading(false);
      console.error("Error changing password:", error);

      // Handle different types of errors
      if (error.response) {
        // The request was made and the server responded with an error status
        const { status, data } = error.response;

        switch (status) {
          case 400:
            if (data.msg === "Invalid Email") {
              toast.error("Invalid email address. Please check your email.");
            } else if (data.msg) {
              toast.error(data.msg);
            } else if (data.message) {
              toast.error(data.message);
            } else {
              toast.error("Bad request. Please check your input.");
            }
            break;

          case 401:
            toast.error("Unauthorized. Please login again.");
            break;

          case 403:
            toast.error("You don't have permission to change this password.");
            break;

          case 404:
            toast.error("User not found. Please check your email.");
            break;

          case 409:
            toast.error("Password change conflict. Please try again.");
            break;

          case 500:
            if (data.error) {
              toast.error(`Server error: ${data.error}`);
            } else if (data.message) {
              toast.error(data.message);
            } else {
              toast.error("Server error. Please try again later.");
            }
            break;

          default:
            if (data.msg) {
              toast.error(data.msg);
            } else if (data.message) {
              toast.error(data.message);
            } else {
              toast.error(`Error ${status}: Please try again.`);
            }
        }

      } else if (error.request) {
        // The request was made but no response was received
        console.error("No response received:", error.request);
        toast.error("No response from server. Please check your connection.");
      } else {
        // Something happened in setting up the request
        console.error("Error setting up request:", error.message);
        toast.error("An error occurred. Please try again.");
      }
    } finally {
      setIsLoading(false);
    }
  };




  return (
    <>
      {isLoading && (
        <div className="spinner-overlay">
          <Spinner size="xl" color="pink.500" />
        </div>
      )}
      <div className="flex items-center justify-center w-full h-full signin-main-div mt-2">
        <div className="form_container mt-2">
          <form>
            <div className="title_container">
              <p className="title" style={{ color: '#661E33' }}>Forgot Password</p>
              <span className="subtitle" style={{ color: '#661E33' }}>
                Enter your Email to receive a password reset link.
              </span>
            </div>

            <div className="input_container">
              <label className="input_label" style={{ color: '#661E33' }} htmlFor="email_field">
                Email
              </label>
              <div className="d-flex">
                <input
                  placeholder="name@mail.com"
                  name="email"
                  type="email"
                  value={email}
                  className="input_field"
                  id="email_field"
                  onChange={(e) => setEmail(e.target.value)}
                  required
                  style={{ color: '#661E33' }}
                />
                <button
                  type="button"
                  style={{ backgroundColor: '#66944B' }}

                  className="mx-2  send-otp-btn "
                  onClick={sendEmail}
                  disabled={timerActive}
                >
                  {timerActive ? `Send OTP (${timer})` : "Send OTP"}
                </button>
              </div>
            </div>

            <div className="input_container">
              <label className="input_label" style={{ color: '#661E33' }} htmlFor="otp">
                OTP
              </label>
              <div className="d-flex">
                <div className="d-flex justify-content-center items-center">
                  {otp.map((digit, index) => (
                    <input
                      key={index}
                      ref={(el) => (inputRefs.current[index] = el)}
                      className="w-12 h-12 m-1 text-center font-bold"
                      style={{ border: "1px solid #d7d2d2", color: "#034C8C" }}
                      type="text"
                      maxLength={1}
                      value={digit}
                      onChange={(e) => handleChange(index, e)}
                      onKeyDown={(e) => handleKeyDown(index, e)}
                    />
                  ))}
                </div>
                <button
                  type="button"
                  style={{ backgroundColor: '#66944B' }}
                  className="mx-2 verify-otp-btn mt-2 h-10"

                  onClick={verifyOTP}
                >
                  Verify OTP
                </button>
              </div>
            </div>

            {isOtpVerified && (
              <>
                <div className="input_container">
                  <label className="input_label" htmlFor="password_field">
                    Create New Password
                  </label>
                  <div
                    className="d-flex rounded-3 text-center"
                    style={{ border: "1px solid #EEEEEE", height: "50px" }}
                  >
                    <input
                      placeholder="Password"
                      name="password"
                      type={showPassword ? "text" : "password"}
                      id="password_field"
                      required
                      onChange={(e) => setPassword(e.target.value)}
                      style={{ border: "none" }}
                      className="form-control border-0 shadow-none px-3 py-2 text-gray-600"
                    />

                    <span
                      onClick={togglePasswordVisibility}
                      className="d-flex mx-2 "
                      style={{ alignItems: "center", cursor: "pointer" }}
                    >
                      {showPassword ? (
                        <Eye className="cursor-pointer" />
                      ) : (
                        <EyeOff className="cursor-pointer" />
                      )}
                    </span>
                  </div>
                </div>

                {passwordError && (
                  <p className="error_message">{passwordError}</p>
                )}

                <div className="input_container">
                  <label
                    className="input_label"
                    htmlFor="confirm_password_field"
                  >
                    Confirm Password
                  </label>
                  <div
                    className="d-flex rounded-3 text-center"
                    style={{ border: "1px solid #EEEEEE", height: "50px" }}
                  >
                    <input
                      placeholder="Confirm Password"
                      name="confirmPassword"
                      type={showConfirmPassword ? "text" : "password"}
                      id="confirm_password_field"
                      required
                      onChange={(e) => setConfirmPassword(e.target.value)}
                      style={{ border: "none" }}
                      className="form-control border-0 shadow-none px-3 py-2 text-gray-600"
                    />
                    <span
                      onClick={toggleConfirmPasswordVisibility}
                      className="d-flex mx-2 "
                      style={{ alignItems: "center", cursor: "pointer" }}
                    >
                      {showConfirmPassword ? (
                        <Eye className="cursor-pointer" />
                      ) : (
                        <EyeOff className="cursor-pointer" />
                      )}
                    </span>
                  </div>
                </div>

                <button
                  title="Submit"
                  type="submit"
                  className="sign-in_btn my-4"
                  onClick={handleChangePassword}
                >
                  <span>Submit</span>
                </button>
              </>
            )}
          </form>
        </div>
      </div>
    </>
  );
};

export default AdminForgotPassWord;
